import * as yup from 'yup';

import { ADDITIONAL_TARIFFS_VALIDATION_SCHEMA } from './AdditionalTariffValidationSchema';
import { COMPLIANCE_PRICING_VALIDATION_SCHEMA } from './CompliancePricingValidationSchema';
import { TRANSACTION_PRICING_VALIDATION } from './TripleToggleValidationSchema';

const transactionPricingShape = TRANSACTION_PRICING_VALIDATION();

export const TRANSACTION_PRICING_OFFER_VALIDATION_SCHEMA = yup.object().shape({
    offerName: yup.string().required('Required'),
    revenueShare: yup
        .number()
        .min(0, 'Minimum amount of revenue shares is 0%')
        .max(100, 'Your entry exceeds 100%')
        .required('Required'),
    transactionPricing: yup.object().shape(transactionPricingShape),
    additionalTariffs: ADDITIONAL_TARIFFS_VALIDATION_SCHEMA,
    ...COMPLIANCE_PRICING_VALIDATION_SCHEMA,
});
